<template>
  <div>
    <footer id="ft-footer" class="ft-footer haslayout">
      <div class="ft-footerarea">
        <div class="container">
          <div class="row">
            <div class="ft-threecolumn">
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                <div class="ft-footercol">
                  <ul class="ft-contact">
                    <li>
                      <i class="icon-apartment"></i>
                      <address> {{getHeaderFooterData.address}}</address>
                    </li>
                    <li>
                      <i class="icon-phone-handset"></i>
                      <span>
                        <em>+88{{getHeaderFooterData.mobile_no}}</em>
                      </span>
                    </li>
                    <li>
                      <i class="icon-envelope"></i>
                      <span>
                        <em><a href="#"> {{getHeaderFooterData.email}}</a></em>
                      </span>
                    </li>
                  </ul>
<!--                  <ul class="ft-socialicon">-->
<!--                    <li class="ft-facebook">-->
<!--                      <a href="javascript:void(0);"-->
<!--                        ><i class="fab fa-facebook-f"></i-->
<!--                      ></a>-->
<!--                    </li>-->
<!--                    <li class="ft-googleplus">-->
<!--                      <a href="javascript:void(0);"-->
<!--                        ><i class="fab fa-google-plus-g"></i-->
<!--                      ></a>-->
<!--                    </li>-->
<!--                  </ul>-->
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
                <div class="ft-footercol ft-widget ft-widgetnavigation">
                  <div class="ft-widgettitle">
                    <h3>Information</h3>
                  </div>
                  <div class="ft-widgetcontent">
                    <ul>
                      <li><a  href="/">E-Library</a></li>
                      <li><a href="/institute-profile">Institutes</a></li>
                      <li><a href="/faq">FAQ</a></li>
                    </ul>
                    <ul>
                      <li v-if="getResponsiveLastLimit > 576"><a href="/admin/student-list">User Management</a></li>
                      <li><a href="/web-portal-list">Content</a></li>
                    </ul>
                    <ul>
                      <li v-if="getResponsiveLastLimit > 576"><a @click="dashBoardMethod()">Dashboard</a></li>
                      <li>
                          <a href="/blog">Blog</a>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ft-footerbar">
        <a
          id="allbutton-btnbacktotop"
          class="allbutton-btnbacktotop"
          href="javascript:void(0);"
          @click="goScrollTop"
          ><i class="icon-chevron-up"></i
        ></a>
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <span class="ft-copyright">Developed and maintained by ME & HMD</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "WebPortalFooter",
  computed: {
    getHeaderFooterData(){
      return this.$store.getters.getHeaderFooterPublicData;
    },
    getResponsiveLastLimit(){
      return window.innerWidth;
    }
  },
  methods: {
    goScrollTop(){
      this.$emit("scrollToTop");
    },
            dashBoardMethod(){

                      let myToken = localStorage.getItem('dgmeToken');
                      let currentUser=JSON.parse(localStorage.getItem('currentUser'))

                      this.$store.dispatch("callfacilityDashboardData").then((data) => {
                        
                        if(data.type == "teacher_dashboard"){
                          localStorage.setItem("thisDashboard", "/admin/teacher-dashboard");
                          this.$router.push("/admin/teacher-dashboard");
                        }
                        
                        if(data.type == "student_dashboard"){
                         //  console.log("data.type",data.type);
                          localStorage.setItem("thisDashboard", "/admin/student-dashboard");
                          this.$router.push("/admin/student-dashboard");
                        }
                        if(data.type == "admin_dashboard"){
                          localStorage.setItem("thisDashboard", "/admin/institute-dashboard");
                          this.$router.push("/admin/institute-dashboard");
                        }
                        if(data.type == undefined){
                          localStorage.setItem("thisDashboard", "/admin/institute-dashboard");
                          this.$router.push("/admin/institute-dashboard");
                        }
            //  else {
            //    localStorage.setItem("thisDashboard", "/admin/institute-dashboard");
            //   this.$router.push("/admin/institute-dashboard");
            // }
            
          });
         // this.$store.dispatch("callfacilityDashboardData");
        //  console.log("myToken",myToken);
         if(myToken != "null"){
         //  console.log("crnt", currentUser)
          
          
        }
        
        

        else{
        //  console.log("dont");
         var currentUrl = "/"
         localStorage.setItem("currentUrl", currentUrl);
         this.$router.push("/login");
       }

     }
  }
};
</script>

<style scoped>
    /*.v-application a {*/
    /*    color: #ffffff;*/
    /*}*/
</style>
